import TextField, { type TextFieldProps } from "@mui/material/TextField"
import type { FieldRenderProps } from "react-final-form"

import type { SxStyles } from "@/types/util"

const styles = {
  textFiled: { width: "100%", maxWidth: "30rem" },
} satisfies SxStyles

type Props = FieldRenderProps<string> & {
  style?: object
  type?: string | null
  placeholder?: string | null
  label?: string | null
  isMultiline?: boolean
  inputProps?: object | null
  InputLabelProps?: TextFieldProps["InputLabelProps"]
  helperText?: string
  FormHelperTextProps?: TextFieldProps["FormHelperTextProps"]
}

const FinalFormTextField = ({
  input: { name, onChange, value, ...restInput },
  meta,
  style = {},
  type = null,
  placeholder = null,
  label = null,
  isMultiline = false,
  inputProps = null,
  InputLabelProps = {},
  helperText = " ",
  FormHelperTextProps = {},
  ...restProps
}: Props) => {
  const hasError = !!(meta.error && meta.touched)
  return (
    <TextField
      sx={[styles.textFiled, style]}
      placeholder={placeholder ?? undefined}
      label={label}
      type={type ?? undefined}
      name={name}
      helperText={hasError ? meta.error : helperText}
      FormHelperTextProps={{
        sx: {
          ...(FormHelperTextProps.style ?? {}),
          marginTop: "8px",
          lineHeight: "1em",
          fontSize: "0.6rem",
        },
      }}
      error={hasError}
      InputProps={{ ...restInput, ...(inputProps ?? {}) }}
      onChange={onChange}
      value={value}
      multiline={isMultiline}
      InputLabelProps={InputLabelProps}
      variant="standard"
      {...restProps}
    />
  )
}

export default FinalFormTextField
